<template>
  <v-toolbar app :clipped-left="$vuetify.breakpoint.mdAndUp" color="white" fixed>
    <v-toolbar-title>
      <img src="~@/assets/img/logo_new.png">
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  name: 'Header'
}
</script>

